import { render, staticRenderFns } from "./ReportOrderReturn.vue?vue&type=template&id=273ae4a5&"
import script from "./ReportOrderReturn.vue?vue&type=script&lang=js&"
export * from "./ReportOrderReturn.vue?vue&type=script&lang=js&"
import style0 from "./ReportOrderReturn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports